import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, inject, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { KbDataExtractionRequestService } from 'src/app/services/feature/data-extraction-request/kb-data-extraction-request.service';
import { KbFileABSService } from 'src/app/services/feature/myacc-popup-fileService/kbfileABSService.service';
import { KbFileEBSService } from 'src/app/services/feature/myacc-popup-fileService/kbfileEBSService.service';
import { KbFileFLCService } from 'src/app/services/feature/myacc-popup-fileService/kbfileFLCService.service';
import { KbFileService } from 'src/app/services/feature/myacc-popup-fileService/kbfileService.service';
import { KbFileIntelliparkService } from 'src/app/services/feature/myacc-popup-fileService/kbfileIntelliparkService.service';

export interface FileMeta {
  fileName: string;
  fileSize: number;
}

export interface UniqueEcu {
  name: string;
  uploadedFiles?: FileMeta[];
  filesByModel?: Record<string, FileMeta[]>;
}

@Component({
  selector: 'app-kb-ecu-information',
  templateUrl: './kb-ecu-information.component.html',
  styleUrl: './kb-ecu-information.component.scss',
  standalone: false
})

export class KbECUInformationComponent {
  private datePipe = inject(DatePipe);
  form!: FormGroup;

  dtcRecordsCount = 1;
  photoCount = { abs: 1, ebs90: 0, flc20_black: 0 };
  isDuplicateFile: boolean = false;
  isDuplicateFileABS: boolean = false;
  isDuplicateFileEBS: boolean = false;
  isDuplicateFileFLC: boolean = false;
  isDuplicateFileIntellipark: boolean = false;

  isMaxFileSize: boolean = false;
  isMaxFileSizeABS: boolean = false;
  isMaxFileSizeEBS: boolean = false;
  isMaxFileSizeFLC: boolean = false;
  isMaxFileSizeIntellipark: boolean = false;

  isUploadfileSuccess: boolean = false;
  isUploadfileSuccessABS: boolean = false;
  isUploadfileSuccessEBS: boolean = false;
  isUploadfileSuccessFLC: boolean = false;
  isUploadfileSuccessIntellipark: boolean = false;

  isAtleastOnefileIsThere: boolean = true;
  isAtleastOnefileIsThereABS: boolean = true;
  isAtleastOnefileIsThereEBS: boolean = true;
  isAtleastOnefileIsThereFLC: boolean = true;
  isAtleastOnefileIsThereIntellipark: boolean = true;

  fileLength$: Observable<any> = this.fileService.getCurrentFileCount();
  fileCurrentFiles$: Observable<any> = this.fileService.getCurrentFilesInfo();

  fileLengthABS$: Observable<any> = this.fileServiceABS.getCurrentFileCount();
  fileCurrentFilesABS$: Observable<any> = this.fileServiceABS.getCurrentFilesInfo();

  fileLengthEBS$: Observable<any> = this.fileServiceEBS.getCurrentFileCount();
  fileCurrentFilesEBS$: Observable<any> = this.fileServiceEBS.getCurrentFilesInfo();

  fileLengthFLC$: Observable<any> = this.fileServiceFLC.getCurrentFileCount();
  fileCurrentFilesFLC$: Observable<any> = this.fileServiceFLC.getCurrentFilesInfo();


  fileLengthIntellipark$: Observable<any> = this.fileServiceIntellipark.getCurrentFileCount();
  fileCurrentFilesIntellipark$: Observable<any> = this.fileServiceIntellipark.getCurrentFilesInfo();

  popupOpenSerialNumber: boolean = false;
  popupOpenECUPhoto: boolean = false;
  popupOpenDTC: boolean = false;
  submitted = false;
  today: Date = new Date();
  bsConfig = { dateInputFormat: 'DD.MM.YYYY', showWeekNumbers: false, displayOneMonthRange: true };
  bsconfigDate: string = '';
  localizedDateFormat: any;
  @ViewChild('popUpBoxFileUpload') PopUpBoxFileUpload: any;
  @ViewChild('popUpBoxABSPhotoUpload') PopUpBoxABSPhotoUpload: any;
  @ViewChild('popUpBoxEBSPhotoUpload') PopUpBoxEBSPhotoUpload: any;
  @ViewChild('popUpBoxFLCPhotoUpload') PopUpBoxFLCPhotoUpload: any;
  @ViewChild('PopUpBoxintelliparkPhotoUpload') PopUpBoxintelliparkPhotoUpload: any;
  SelectedECU: any[] = [];
  labelText: string
  selectedFiles: File[] = [];
  uploadedFileCount: number = 0;
  uniqueEcu: UniqueEcu[] = [];
  errorMsg: string;

  @ViewChild('labelA') labelA!: ElementRef<HTMLSpanElement>;
  @ViewChild('labelB') labelB!: ElementRef<HTMLSpanElement>;
  @ViewChild('labelC') labelC!: ElementRef<HTMLSpanElement>;
  @ViewChild('labelD') labelD!: ElementRef<HTMLSpanElement>;


  constructor(private fb: FormBuilder, private dialog: MatDialog, 
    private fileService: KbFileService,
    private fileServiceABS: KbFileABSService,
    private fileServiceEBS: KbFileEBSService,
    private fileServiceFLC: KbFileFLCService,
    private fileServiceIntellipark: KbFileIntelliparkService,
    private cdr: ChangeDetectorRef,) { }
  private dataExtractionService = inject(KbDataExtractionRequestService);
  ngOnInit(): void {
    this.form = this.fb.group({
      ecu_abs: [false],
      ecu_ebs90: [false],
      ecu_flc20_black: [false],
      ecu_intellipark_dash: [false],

      abs_serial: [''],
      ebs90_serial: [''],
      flc20_black_serial: [''],
      intellipark_dash_serial: [''],
      sdp: [false,],
      autoVue_ecu: [false],
      autoVue_3g_camera: [false],
      flr21_flr25: [false],
      ecuremovedvehiclename: ['', Validators.required],
      removalDate: ['', Validators.required],     // ISO date string from <input type="date">
      removalTime: [''],                             // optional HH:MM (24h)
      senderName: ['', Validators.required],
      carrierName: ['', Validators.required],
      trackingNumber: ['']

    });

    // Set up conditional required validators
    this.bindConditionalRequired('ecu_abs', 'abs_serial');
    this.bindConditionalRequired('ecu_ebs90', 'ebs90_serial');
    this.bindConditionalRequired('ecu_flc20_black', 'flc20_black_serial');
    this.bindConditionalRequired('ecu_intellipark_dash', 'intellipark_dash_serial');
    this.form.get('sdp')?.disable();
    this.form.get('autoVue_ecu')?.disable();
    this.form.get('autoVue_3g_camera')?.disable();
    this.form.get('flr21_flr25')?.disable();
  }

  private bindConditionalRequired(checkboxKey: string, controlKey: string): void {
    const checkbox = this.form.get(checkboxKey);
    const control = this.form.get(controlKey);
    if (!checkbox || !control) return;

    const apply = () => {
      control!.clearValidators();
      if (checkbox!.value) control!.addValidators([Validators.required]);
      control!.updateValueAndValidity({ emitEvent: false });
    };

    apply();
    checkbox.valueChanges.subscribe(apply);
  }

  checkboxChange(event, checkboxKey: string, controlKey: string, label?: string) {
    console.log(this.SelectedECU);
    const isChecked = !!this.form.get(checkboxKey)?.value
    const checkbox = this.form.get(checkboxKey);
    const control = this.form.get(controlKey);
    if (label) {
      this.labelText = label;
    }
    const obj = {
      name: this.labelText,
      serialNumber: control.value
    }

    // Find index if item already exists based on name
    const idx = this.SelectedECU.findIndex(
      x => x.name?.trim() === obj.name?.trim()
    );

    if (checkbox.value) {
      // --- ADD or UPDATE ---
      if (idx !== -1) {
        // Update serialNumber only
        this.SelectedECU[idx].serialNumber = obj.serialNumber;
      } else {
        // Push new entry
        this.SelectedECU.push(obj);
      }
    } else {
      // --- REMOVE when unchecked ---
      if (idx !== -1) {
        this.SelectedECU.splice(idx, 1);
      }
    }
    console.log(this.SelectedECU);
  }


  uniqueByNameKeepLast(items) {
    const map = new Map<string, []>();
    for (const item of items) {
      map.set(item.name, item); // latest item overwrites older ones
    }
    return Array.from(map.values());
  }


  isInvalid(controlName: string): boolean {
    const c = this.form.get(controlName);
    return !!c && c.invalid && (c.dirty || c.touched);
  }

  onViewAddDtc(): void { console.log('Open DTC View/Add'); }
  onViewAddPhoto(key: 'abs' | 'ebs90' | 'flc20_black'): void { console.log('Open photo View/Add for', key); }
  openHelp(topic: string): void { console.log('Help:', topic); }

  uploadFile(index: number) {
    const dialogRef = this.dialog.open(this.PopUpBoxFileUpload, {
      data: {
        index: index,
      },
    });
  }

  ABSPhotoUpload(index: number) {
    const dialogRef = this.dialog.open(this.PopUpBoxABSPhotoUpload, {
      data: {
        index: index,
      },
    });
  }

  EBSPhotoUpload(index: number) {
    const dialogRef = this.dialog.open(this.PopUpBoxEBSPhotoUpload, {
      data: {
        index: index,
      },
    });
  }


  FLCPhotoUpload(index: number) {
    const dialogRef = this.dialog.open(this.PopUpBoxFLCPhotoUpload, {
      data: {
        index: index,
      },
    });
  }

  intelliparkPhotoUpload(index: number) {
    const dialogRef = this.dialog.open(this.PopUpBoxintelliparkPhotoUpload, {
      data: {
        index: index,
      },
    });
  }
  closePopUpBoxFileUpload() {
    this.dialog.closeAll();
  }

  /* fileSelector(event: any, modelName: string) {
    const files = Object.values(event.files);
    const TotalFileSizeExceeds = this.fileService.isTotalFileSizeLessThan9MB();

    files.map((file: File) => {
      if (!this.fileService.isFileSizeLessThan9MB(file) && this.fileService.isAtLeastOneFilePresent()) {
        this.isMaxFileSize = true;
        this.fileService.clearAllFiles();
      }
      else if (!this.fileService.isNotDuplicate(file.name)) {
        this.isDuplicateFile = true;
      }
      else {
        this.fileService.addFile(file);
        this.isAtleastOnefileIsThere = !this.fileService.isAtLeastOneFilePresent();
        if (!this.fileService.isTotalFileSizeLessThan9MB()) {
          this.fileService.clearAllFiles();
          this.isAtleastOnefileIsThere = !this.fileService.isAtLeastOneFilePresent();
          this.isMaxFileSize = true;
        }
        this.cdr.detectChanges();
      }
    });
    if (this.isMaxFileSize) {
      this.fileService.clearAllFiles();
    }

    setTimeout(() => {
      this.isDuplicateFile = false;
      this.isMaxFileSize = false;
      this.isUploadfileSuccess = false;
    }, 10000);
  }
 */
  fileSelector(input: HTMLInputElement) {
    // Guard: make sure we really received the input element
    if (!input || !('files' in input)) {
      this.errorMsg = 'Unexpected error: file input not found.';
      console.warn('onDtcFileChange called without a valid HTMLInputElement', { input });
      return;
    }

    const files = Array.from(input.files || []);
    this.errorMsg = '';
    this.isDuplicateFile = false;
    this.isMaxFileSize = false;

    // Allowed sets (extensions + MIME)
    const allowedExt = new Set(['.html', '.htm', '.xml', '.zip']);
    const allowedMime = new Set([
      'text/html',
      'application/zip',
      'application/x-zip-compressed',
      'application/xml',
      'text/xml',
      'application/xhtml+xml'
    ]);

    const hasAllowedExtension = (name: string): boolean => {
      const dot = name.lastIndexOf('.');
      if (dot === -1) return false;
      return allowedExt.has(name.substring(dot).toLowerCase());
    };

    const isAllowed = (file: File): boolean => {
      // Prefer MIME when present; fall back to extension
      if (file.type && allowedMime.has(file.type)) return true;
      return hasAllowedExtension(file.name);
    };

    // If any invalid file is selected, block entire selection, reset and message
    const invalidFiles = files.filter(f => !isAllowed(f));
    if (invalidFiles.length > 0) {
      input.value = ''; // clear file picker selection
      this.fileService.clearAllFiles();
      this.errorMsg = `Only html, xml, or zip files are permitted. Blocked: ${invalidFiles.map(f => f.name).join(', ')}`;
      // Auto-clear error after 10s (consistent with your current UX)
      // setTimeout(() => (this.errorMsg = ''), 10000);
      return;
    }

    // Proceed with your existing validations per file
    for (const file of files) {

      // Size validations
      if (!this.fileService.isFileSizeLessThan9MB(file) && this.fileService.isAtLeastOneFilePresent()) {
        this.isMaxFileSize = true;
        this.fileService.clearAllFiles();
        break; // stop processing more files
      }

      // Duplicate validations
      if (!this.fileService.isNotDuplicate(file.name)) {
        this.isDuplicateFile = true;
        continue; // skip this file, allow others to proceed
      }

      // Add file if all validations pass
      this.fileService.addFile(file);

      // Re-check total size after adding
      if (!this.fileService.isTotalFileSizeLessThan9MB()) {
        this.fileService.clearAllFiles();
        this.isMaxFileSize = true;
        break;
      }
    }

    // Update UI flags
    this.isAtleastOnefileIsThere = !this.fileService.isAtLeastOneFilePresent();

    // If total/individual size exceeded, clear selection & input
    if (this.isMaxFileSize) {
      input.value = '';
      this.fileService.clearAllFiles();
    }

    this.cdr.detectChanges();

    // Reset transient flags after 10s (same behavior as you had)
    setTimeout(() => {
      this.isDuplicateFile = false;
      this.isMaxFileSize = false;
      this.isUploadfileSuccess = false;
    }, 10000);
  }

  /* fileSelectorABS(event: any, modelName: string) {
    const files = Object.values(event.files);
    const TotalFileSizeExceeds = this.fileServiceABS.isTotalFileSizeLessThan9MB();

    files.map((file: File) => {
      if (!this.fileServiceABS.isFileSizeLessThan9MB(file) && this.fileServiceABS.isAtLeastOneFilePresent()) {
        this.isMaxFileSize = true;
        this.fileServiceABS.clearAllFiles();
      }
      else if (!this.fileServiceABS.isNotDuplicate(file.name)) {
        this.isDuplicateFile = true;
      }
      else {
        this.fileServiceABS.addFile(file);
        this.isAtleastOnefileIsThere = !this.fileServiceABS.isAtLeastOneFilePresent();
        if (!this.fileServiceABS.isTotalFileSizeLessThan9MB()) {
          this.fileServiceABS.clearAllFiles();
          this.isAtleastOnefileIsThere = !this.fileServiceABS.isAtLeastOneFilePresent();
          this.isMaxFileSize = true;
        }
        this.cdr.detectChanges();
      }
    });
    if (this.isMaxFileSize) {
      this.fileServiceABS.clearAllFiles();
    }

    setTimeout(() => {
      this.isDuplicateFile = false;
      this.isMaxFileSize = false;
      this.isUploadfileSuccess = false;
    }, 10000);
  } */
  fileSelectorABS(input: HTMLInputElement, modelName: string) {
    // Guard against unexpected calls
    if (!input || !('files' in input)) {
      this.errorMsg = 'Unexpected error: file input not found.';
      return;
    }

    const files = Array.from(input.files || []);

    // Reset transient flags/messages
    this.errorMsg = '';
    this.isDuplicateFileABS = false;
    this.isMaxFileSizeABS = false;

    // --- Allowed image types ---
    // If your security policy disallows SVG, keep it excluded.
    const allowedExt = new Set(['.png', '.jpg', '.jpeg', '.gif', '.bmp', '.webp', '.tif']); // no .svg for safety
    const allowedMime = new Set([
      'image/png',
      'image/jpeg',
      'image/gif',
      'image/bmp',
      'image/webp',
      'image/tif'
      // deliberately not adding 'image/svg+xml'
    ]);

    const getExt = (name: string): string => {
      const dot = name.lastIndexOf('.');
      return dot === -1 ? '' : name.substring(dot).toLowerCase();
    };

    const hasAllowedExtension = (name: string): boolean => allowedExt.has(getExt(name));

    const isAllowed = (file: File): boolean => {
      // Prefer MIME when provided by the browser; fallback to extension
      if (file.type && allowedMime.has(file.type)) return true;
      return hasAllowedExtension(file.name);
    };

    // ❌ Block the entire selection if any file is not an image
    const invalid = files.filter(f => !isAllowed(f));
    if (invalid.length) {
      input.value = '';                         // clear the picker
      this.fileServiceABS.clearAllFiles();      // clear internal list
      this.errorMsg = `Only image files are permitted (PNG, JPG, JPEG, GIF, BMP, WEBP,TIF). Blocked: ${invalid.map(f => f.name).join(', ')}`;
      setTimeout(() => (this.errorMsg = ''), 10000);
      return;
    }

    // ✅ Proceed with your size + duplicate checks for each file
    for (const file of files) {
      // Individual file size check
      if (!this.fileServiceABS.isFileSizeLessThan9MB(file) && this.fileServiceABS.isAtLeastOneFilePresent()) {
        this.isMaxFileSizeABS = true;
        this.fileServiceABS.clearAllFiles();
        break;
      }

      // Duplicate by name
      if (!this.fileServiceABS.isNotDuplicate(file.name)) {
        this.isDuplicateFileABS = true;
        continue; // skip this file, keep validating others
      }

      // Add the file
      this.fileServiceABS.addFile(file);

      // Total size check after adding
      if (!this.fileServiceABS.isTotalFileSizeLessThan9MB()) {
        this.fileServiceABS.clearAllFiles();
        this.isMaxFileSizeABS = true;
        break;
      }
    }

    // UI state
    this.isAtleastOnefileIsThereABS = !this.fileServiceABS.isAtLeastOneFilePresent();

    // If any size rule was hit, reset input and internal state
    if (this.isMaxFileSizeABS) {
      input.value = '';
      this.fileServiceABS.clearAllFiles();
    }

    this.cdr.detectChanges();

    // Reset transient flags after 10s (matches your existing UX)
    setTimeout(() => {
      this.isDuplicateFileABS = false;
      this.isMaxFileSizeABS = false;
      this.isUploadfileSuccessABS = false;
    }, 10000);
  }

  /*  fileSelectorEBS(event: any, modelName: string) {
     const files = Object.values(event.files);
     const TotalFileSizeExceeds = this.fileServiceEBS.isTotalFileSizeLessThan9MB();
 
     files.map((file: File) => {
       if (!this.fileServiceEBS.isFileSizeLessThan9MB(file) && this.fileServiceEBS.isAtLeastOneFilePresent()) {
         this.isMaxFileSize = true;
         this.fileServiceEBS.clearAllFiles();
       }
       else if (!this.fileServiceEBS.isNotDuplicate(file.name)) {
         this.isDuplicateFile = true;
       }
       else {
         this.fileServiceEBS.addFile(file);
         this.isAtleastOnefileIsThere = !this.fileServiceEBS.isAtLeastOneFilePresent();
         if (!this.fileServiceEBS.isTotalFileSizeLessThan9MB()) {
           this.fileServiceEBS.clearAllFiles();
           this.isAtleastOnefileIsThere = !this.fileServiceEBS.isAtLeastOneFilePresent();
           this.isMaxFileSize = true;
         }
         this.cdr.detectChanges();
       }
     });
     if (this.isMaxFileSize) {
       this.fileServiceEBS.clearAllFiles();
     }
 
     setTimeout(() => {
       this.isDuplicateFile = false;
       this.isMaxFileSize = false;
       this.isUploadfileSuccess = false;
     }, 10000);
   } */

  fileSelectorEBS(input: HTMLInputElement, modelName: string) {
    // Guard against unexpected calls
    if (!input || !('files' in input)) {
      this.errorMsg = 'Unexpected error: file input not found.';
      return;
    }

    const files = Array.from(input.files || []);

    // Reset transient flags/messages
    this.errorMsg = '';
    this.isDuplicateFileEBS = false;
    this.isMaxFileSizeEBS = false;

    // --- Allowed image types ---
    // If your security policy disallows SVG, keep it excluded.
    const allowedExt = new Set(['.png', '.jpg', '.jpeg', '.gif', '.bmp', '.webp', '.tif']); // no .svg for safety
    const allowedMime = new Set([
      'image/png',
      'image/jpeg',
      'image/gif',
      'image/bmp',
      'image/webp',
      'image/tif',
      // deliberately not adding 'image/svg+xml'
    ]);

    const getExt = (name: string): string => {
      const dot = name.lastIndexOf('.');
      return dot === -1 ? '' : name.substring(dot).toLowerCase();
    };

    const hasAllowedExtension = (name: string): boolean => allowedExt.has(getExt(name));

    const isAllowed = (file: File): boolean => {
      // Prefer MIME when provided by the browser; fallback to extension
      if (file.type && allowedMime.has(file.type)) return true;
      return hasAllowedExtension(file.name);
    };

    // ❌ Block the entire selection if any file is not an image
    const invalid = files.filter(f => !isAllowed(f));
    if (invalid.length) {
      input.value = '';                         // clear the picker
      this.fileServiceABS.clearAllFiles();      // clear internal list
      this.errorMsg = `Only image files are permitted (PNG, JPG, JPEG, GIF, BMP, WEBP,TIF). Blocked: ${invalid.map(f => f.name).join(', ')}`;
      setTimeout(() => (this.errorMsg = ''), 10000);
      return;
    }

    // ✅ Proceed with your size + duplicate checks for each file
    for (const file of files) {
      // Individual file size check
      if (!this.fileServiceEBS.isFileSizeLessThan9MB(file) && this.fileServiceEBS.isAtLeastOneFilePresent()) {
        this.isMaxFileSizeEBS = true;
        this.fileServiceABS.clearAllFiles();
        break;
      }

      // Duplicate by name
      if (!this.fileServiceEBS.isNotDuplicate(file.name)) {
        this.isDuplicateFileEBS = true;
        continue; // skip this file, keep validating others
      }

      // Add the file
      this.fileServiceEBS.addFile(file);

      // Total size check after adding
      if (!this.fileServiceEBS.isTotalFileSizeLessThan9MB()) {
        this.fileServiceABS.clearAllFiles();
        this.isMaxFileSizeEBS = true;
        break;
      }
    }

    // UI state
    this.isAtleastOnefileIsThereEBS = !this.fileServiceEBS.isAtLeastOneFilePresent();

    // If any size rule was hit, reset input and internal state
    if (this.isMaxFileSizeEBS) {
      input.value = '';
      this.fileServiceEBS.clearAllFiles();
    }

    this.cdr.detectChanges();

    // Reset transient flags after 10s (matches your existing UX)
    setTimeout(() => {
      this.isDuplicateFileEBS = false;
      this.isMaxFileSizeEBS = false;
      this.isUploadfileSuccessEBS = false;
    }, 10000);
  }

  /*  fileSelectorFLC(event: any, modelName: string) {
     const files = Object.values(event.files);
     const TotalFileSizeExceeds = this.fileServiceFLC.isTotalFileSizeLessThan9MB();
 
     files.map((file: File) => {
       if (!this.fileServiceFLC.isFileSizeLessThan9MB(file) && this.fileServiceFLC.isAtLeastOneFilePresent()) {
         this.isMaxFileSize = true;
         this.fileServiceFLC.clearAllFiles();
       }
       else if (!this.fileServiceFLC.isNotDuplicate(file.name)) {
         this.isDuplicateFile = true;
       }
       else {
         this.fileServiceFLC.addFile(file);
         this.isAtleastOnefileIsThere = !this.fileServiceFLC.isAtLeastOneFilePresent();
         if (!this.fileServiceFLC.isTotalFileSizeLessThan9MB()) {
           this.fileServiceFLC.clearAllFiles();
           this.isAtleastOnefileIsThere = !this.fileServiceFLC.isAtLeastOneFilePresent();
           this.isMaxFileSize = true;
         }
         this.cdr.detectChanges();
       }
     });
     if (this.isMaxFileSize) {
       this.fileServiceFLC.clearAllFiles();
     }
 
     setTimeout(() => {
       this.isDuplicateFile = false;
       this.isMaxFileSize = false;
       this.isUploadfileSuccess = false;
     }, 10000);
   } */

  fileSelectorFLC(input: HTMLInputElement, modelName: string) {
    // Guard against unexpected calls
    if (!input || !('files' in input)) {
      this.errorMsg = 'Unexpected error: file input not found.';
      return;
    }

    const files = Array.from(input.files || []);

    // Reset transient flags/messages
    this.errorMsg = '';
    this.isDuplicateFileFLC = false;
    this.isMaxFileSizeFLC = false;

    // --- Allowed image types ---
    // If your security policy disallows SVG, keep it excluded.
    const allowedExt = new Set(['.png', '.jpg', '.jpeg', '.gif', '.bmp', '.webp', '.tif']); // no .svg for safety
    const allowedMime = new Set([
      'image/png',
      'image/jpeg',
      'image/gif',
      'image/bmp',
      'image/webp',
      'image/tif'
      // deliberately not adding 'image/svg+xml'
    ]);

    const getExt = (name: string): string => {
      const dot = name.lastIndexOf('.');
      return dot === -1 ? '' : name.substring(dot).toLowerCase();
    };

    const hasAllowedExtension = (name: string): boolean => allowedExt.has(getExt(name));

    const isAllowed = (file: File): boolean => {
      // Prefer MIME when provided by the browser; fallback to extension
      if (file.type && allowedMime.has(file.type)) return true;
      return hasAllowedExtension(file.name);
    };

    // ❌ Block the entire selection if any file is not an image
    const invalid = files.filter(f => !isAllowed(f));
    if (invalid.length) {
      input.value = '';                         // clear the picker
      this.fileServiceFLC.clearAllFiles();      // clear internal list
      this.errorMsg = `Only image files are permitted (PNG, JPG, JPEG, GIF, BMP, WEBP). Blocked: ${invalid.map(f => f.name).join(', ')}`;
      setTimeout(() => (this.errorMsg = ''), 10000);
      return;
    }

    // ✅ Proceed with your size + duplicate checks for each file
    for (const file of files) {
      // Individual file size check
      if (!this.fileServiceFLC.isFileSizeLessThan9MB(file) && this.fileServiceFLC.isAtLeastOneFilePresent()) {
        this.isMaxFileSizeFLC = true;
        this.fileServiceFLC.clearAllFiles();
        break;
      }

      // Duplicate by name
      if (!this.fileServiceFLC.isNotDuplicate(file.name)) {
        this.isDuplicateFileFLC = true;
        continue; // skip this file, keep validating others
      }

      // Add the file
      this.fileServiceFLC.addFile(file);

      // Total size check after adding
      if (!this.fileServiceFLC.isTotalFileSizeLessThan9MB()) {
        this.fileServiceFLC.clearAllFiles();
        this.isMaxFileSizeFLC = true;
        break;
      }
    }

    // UI state
    this.isAtleastOnefileIsThereFLC = !this.fileServiceFLC.isAtLeastOneFilePresent();

    // If any size rule was hit, reset input and internal state
    if (this.isMaxFileSizeFLC) {
      input.value = '';
      this.fileServiceFLC.clearAllFiles();
    }

    this.cdr.detectChanges();

    // Reset transient flags after 10s (matches your existing UX)
    setTimeout(() => {
      this.isDuplicateFileFLC = false;
      this.isMaxFileSizeFLC = false;
      this.isUploadfileSuccessFLC = false;
    }, 10000);
  }

  fileSelectorIntellipark(input: HTMLInputElement, modelName: string) {
    // Guard against unexpected calls
    if (!input || !('files' in input)) {
      this.errorMsg = 'Unexpected error: file input not found.';
      return;
    }

    const files = Array.from(input.files || []);

    // Reset transient flags/messages
    this.errorMsg = '';
    this.isDuplicateFileIntellipark = false;
    this.isMaxFileSizeIntellipark = false;

    // --- Allowed image types ---
    // If your security policy disallows SVG, keep it excluded.
    const allowedExt = new Set(['.png', '.jpg', '.jpeg', '.gif', '.bmp', '.webp', '.tif']); // no .svg for safety
    const allowedMime = new Set([
      'image/png',
      'image/jpeg',
      'image/gif',
      'image/bmp',
      'image/webp',
      'image/tif'
      // deliberately not adding 'image/svg+xml'
    ]);

    const getExt = (name: string): string => {
      const dot = name.lastIndexOf('.');
      return dot === -1 ? '' : name.substring(dot).toLowerCase();
    };

    const hasAllowedExtension = (name: string): boolean => allowedExt.has(getExt(name));

    const isAllowed = (file: File): boolean => {
      // Prefer MIME when provided by the browser; fallback to extension
      if (file.type && allowedMime.has(file.type)) return true;
      return hasAllowedExtension(file.name);
    };

    // ❌ Block the entire selection if any file is not an image
    const invalid = files.filter(f => !isAllowed(f));
    if (invalid.length) {
      input.value = '';                         // clear the picker
      this.fileServiceIntellipark.clearAllFiles();      // clear internal list
      this.errorMsg = `Only image files are permitted (PNG, JPG, JPEG, GIF, BMP, WEBP). Blocked: ${invalid.map(f => f.name).join(', ')}`;
      setTimeout(() => (this.errorMsg = ''), 10000);
      return;
    }

    // ✅ Proceed with your size + duplicate checks for each file
    for (const file of files) {
      // Individual file size check
      if (!this.fileServiceIntellipark.isFileSizeLessThan9MB(file) && this.fileServiceIntellipark.isAtLeastOneFilePresent()) {
        this.isMaxFileSizeIntellipark = true;
        this.fileServiceIntellipark.clearAllFiles();
        break;
      }

      // Duplicate by name
      if (!this.fileServiceIntellipark.isNotDuplicate(file.name)) {
        this.isDuplicateFileIntellipark = true;
        continue; // skip this file, keep validating others
      }

      // Add the file
      this.fileServiceIntellipark.addFile(file);

      // Total size check after adding
      if (!this.fileServiceIntellipark.isTotalFileSizeLessThan9MB()) {
        this.fileServiceIntellipark.clearAllFiles();
        this.isMaxFileSizeIntellipark = true;
        break;
      }
    }

    // UI state
    this.isAtleastOnefileIsThereIntellipark = !this.fileServiceIntellipark.isAtLeastOneFilePresent();

    // If any size rule was hit, reset input and internal state
    if (this.isMaxFileSizeIntellipark) {
      input.value = '';
      this.fileServiceIntellipark.clearAllFiles();
    }

    this.cdr.detectChanges();

    // Reset transient flags after 10s (matches your existing UX)
    setTimeout(() => {
      this.isDuplicateFileIntellipark = false;
      this.isMaxFileSizeIntellipark = false;
      this.isUploadfileSuccessIntellipark = false;
    }, 10000);
  }
  removefileABS(file: File) {
    // this.uploadedFileCount--
    this.fileServiceABS.deleteFile(file.name);
    this.isAtleastOnefileIsThereABS = !this.fileServiceABS.isAtLeastOneFilePresent();
  }

  removefileEBS(file: File) {
    // this.uploadedFileCount--
    this.fileServiceEBS.deleteFile(file.name);
    this.isAtleastOnefileIsThereEBS = !this.fileServiceEBS.isAtLeastOneFilePresent();
  }

  removefileFLC(file: File) {
    // this.uploadedFileCount--
    this.fileServiceFLC.deleteFile(file.name);
    this.isAtleastOnefileIsThereFLC = !this.fileServiceFLC.isAtLeastOneFilePresent();
  }
  removefileIntellipark(file: File) {
    // this.uploadedFileCount--
    this.fileServiceIntellipark.deleteFile(file.name);
    this.isAtleastOnefileIsThereIntellipark = !this.fileServiceIntellipark.isAtLeastOneFilePresent();
  }
  removefile(file: File) {
    // this.uploadedFileCount--
    this.fileService.deleteFile(file.name);
    this.isAtleastOnefileIsThere = !this.fileService.isAtLeastOneFilePresent();
  }

  fileUploadFunction() {
    this.isAtleastOnefileIsThere = this.fileService.isAtLeastOneFilePresent();
    if (this.isAtleastOnefileIsThere) {
      this.uploadedFileCount++
      this.isUploadfileSuccess = true;
    }
    setTimeout(() => {
      this.isUploadfileSuccess = false;
    }, 7000);
  }

  fileUploadFunctionABS() {
    this.isAtleastOnefileIsThereABS = this.fileServiceABS.isAtLeastOneFilePresent();
    if (this.isAtleastOnefileIsThereABS) {
      // this.uploadedFileCount++
      this.isUploadfileSuccessABS = true;
    }
    setTimeout(() => {
      this.isUploadfileSuccessABS = false;
    }, 7000);
  }

  fileUploadFunctionEBS() {
    this.isAtleastOnefileIsThereEBS = this.fileServiceEBS.isAtLeastOneFilePresent();
    if (this.isAtleastOnefileIsThereEBS) {
      // this.uploadedFileCount++
      this.isUploadfileSuccessEBS = true;
    }
    setTimeout(() => {
      this.isUploadfileSuccessEBS = false;
    }, 7000);
  }

  fileUploadFunctionFLC() {
    this.isAtleastOnefileIsThereFLC = this.fileServiceFLC.isAtLeastOneFilePresent();
    if (this.isAtleastOnefileIsThereFLC) {
      // this.uploadedFileCount++
      this.isUploadfileSuccessFLC = true;
    }
    setTimeout(() => {
      this.isUploadfileSuccessFLC = false;
    }, 7000);
  }
  fileUploadFunctionIntellipark() {
    this.isAtleastOnefileIsThereIntellipark = this.fileServiceIntellipark.isAtLeastOneFilePresent();
    if (this.isAtleastOnefileIsThereIntellipark) {
      // this.uploadedFileCount++
      this.isUploadfileSuccessIntellipark = true;
    }
    setTimeout(() => {
      this.isUploadfileSuccessIntellipark = false;
    }, 7000);
  }
  onSubmit(): void {
    if (this.form.valid) {
      console.log('Submit:', this.form.value);
      // call API
    } else {
      this.form.markAllAsTouched();
    }
  }

  onCancel(): void {
    this.form.reset({
      ecu_abs: false,
      ecu_ebs90: false,
      ecu_flc20_black: false,
      ecu_intellipark_dash: false
    });
  }

  openPopupSerialNumber() {
    this.popupOpenSerialNumber = true;
  }

  closePopupSerialNumber() {
    this.popupOpenSerialNumber = false;
  }

  openPopupECUPhoto() {
    this.popupOpenECUPhoto = true;
  }

  closePopupECUPhoto() {
    this.popupOpenECUPhoto = false;
  }

  openPopupDTC() {
    this.popupOpenDTC = true;
  }

  closePopupDTC() {
    this.popupOpenDTC = false;
  }

  formPayloadData() {
    const dtcmodelPayload = [];
    const photomodelPayload = []
  }



  back() {
    this.dataExtractionService.currentComponent$.next('vehicleInformation');
  }
  next() {
    this.submitted = true;
    // 1) Deduplicate ECU selections
    const uniqueEcu = this.uniqueByNameKeepLast(this.SelectedECU);

    // 2) Collect DTC files
    const dtcFiles: File[] = this.fileService.filesSubject.getValue() ?? [];
    const dtcMeta = dtcFiles.map((file) => ({
      fileName: file.name,
      fileSize: file.size
    }));

    // Fixed index mapping (stable no matter selection order)
    const ECU_INDEX_MAP: Record<string, number> = {
      'Bendix® FLC-20™ Camera (Black)': 2,
      'Bendix® ABS ECU': 0,
      'Bendix® EBS-90™ ECU': 1,
      'Bendix® Intellipark® Dash ECU (DECU)': 3
    };

    // Helper to fetch files by ECU name
    const getFilesForEcu = (ecuName: string): File[] => {
      switch (ecuName) {
        case 'Bendix® FLC-20™ Camera (Black)':
          return this.fileServiceFLC.filesSubjectFLC.getValue() ?? [];
        case 'Bendix® ABS ECU':
          return this.fileServiceABS.filesSubjectABS.getValue() ?? [];
        case 'Bendix® EBS-90™ ECU':
          return this.fileServiceEBS.filesSubjectEBS.getValue() ?? [];
        case 'Bendix® Intellipark® Dash ECU (DECU)':
          return this.fileServiceIntellipark.filesSubjectIntellipark.getValue() ?? [];
        default:
          return [];
      }
    };

    // 3) Build ECU list (metadata only) + keep actual files for FormData
    const removedSelectedECU: any[] = [];
    const ecuFilesForMultipart: { ecuIndex: number; files: File[] }[] = [];

    uniqueEcu.forEach((val: any) => {
      const ecuIndex = ECU_INDEX_MAP[val.name]; // ✅ stable mapping
      if (ecuIndex === undefined) return;       // optional: ignore unknown ECU names

      const ecuFiles = getFilesForEcu(val.name);

      // Attachments metadata only
      const ecuAttachmentsMeta = ecuFiles.map((file) => ({
        fileName: file.name,
        fileSize: file.size
      }));

      removedSelectedECU.push({
        name: val.name,
        serialNumber: val.serialNumber,
        ecuphotoattachmentsInfo: ecuAttachmentsMeta
      });

      ecuFilesForMultipart.push({ ecuIndex, files: ecuFiles });
    });


    // 4) Pure JSON payload (no File objects!)
    const ecuPayload = {
      bdrattachmentsInfo: dtcMeta,
      removedSelectedECU: removedSelectedECU,
      ecuremovedvehiclename: this.form.get('ecuremovedvehiclename')?.value,
      removalDate: this.formatIncidentDate(this.form.get('removalDate')?.value),
      removalTime: this.form.get('removalTime')?.value,
      senderName: this.form.get('senderName')?.value,
      carrierName: this.form.get('carrierName')?.value,
      trackingNumber: this.form.get('trackingNumber')?.value
    };

    const ecuFormData = new FormData();

    // ECU JSON must be stored under key "payload"
    ecuFormData.append('payload', JSON.stringify(ecuPayload));

    // BDR attachments => same key repeated
    (dtcFiles ?? []).forEach((file: File) => {
      ecuFormData.append('bdrattachmentsInfoFiles', file, file.name);
    });

    // ECU files => ecuFiles_0, ecuFiles_1 ...
    // NOTE: ecuFilesForMultipart is like: [{ ecuIndex: 0, files: File[] }, ...]
    (ecuFilesForMultipart ?? []).forEach(({ ecuIndex, files }: any) => {
      (files ?? []).forEach((file: File) => {
        ecuFormData.append(`ecuFiles_${ecuIndex}`, file, file.name);
      });
    });

    // Debug
    console.log('--- ECU FORMDATA ---');
    for (const [k, v] of ecuFormData.entries() as any) {
      if (v instanceof File) console.log(k, `File(${v.name})`);
      else console.log(k, v);
    }

    this.dataExtractionService.setecuInformationData(ecuFormData);
    this.dataExtractionService.currentComponent$.next('incidentInformation');
  }
  formatIncidentDate(date: any) {
    return this.datePipe.transform(date, 'dd/MM/yyyy');
  }
}